import React, { useState, useEffect } from 'react'
import styles from './InsuranceIntegration.module.css'
import { Toggle } from 'components/selections'
import { NotificationCard } from 'components/notification'
import { Button, IconButton } from 'components/button'
import { CheckCircleOFFIcon, PriceCheckIcon } from 'components/icon'
import { Flex } from 'components/flex'
import PublicCertImportModal from '../modal/PublicCertImportModal'
import { callApi, snackBar } from 'utils'

export default function InsuranceIntegrationTab (props) {
  const [certImportModal, setCertImportModal] = useState(false)
  const [certUpdate, setCertUpdate] = useState(false)
  const [data, setData] = useState({})
  const [toggle1, setToggle1] = useState(false)
  const [toggle2, setToggle2] = useState(false)
  const [toggle3, setToggle3] = useState(false)
  const [toggle4, setToggle4] = useState(false)
  const [certYn, setCertYn] = useState('N')
  const [idx, setIdx] = useState('')
  const [derRealFile, setDerRealFile] = useState(null)
  const [keyRealFile, setKeyRealFile] = useState(null)
  const [kcomwelDerRealFile, setKcomwelDerRealFile] = useState(null)
  const [kcomwelKeyRealFile, setKcomwelKeyRealFile] = useState(null)

  const insurancelSetting = async () => {
    let sessionStorage = window.sessionStorage
    let opId = sessionStorage.getItem('userId')

    const postData = {
      opId: opId
    }

    const response = await callApi('api/platform/viewSetting', postData)

    if (response.result) {
      setData(response.data)
      setToggle1(response.data.isNpsSync === 'Y')
      setToggle2(response.data.isNhisSync === 'Y')
      setToggle3(response.data.isKcomwelMonthlySync === 'Y')
      setToggle4(response.data.isKcomwelUnempSync === 'Y')
    }

  }

  const certStatus = async () => {
    let sessionStorage = window.sessionStorage
    let opId = sessionStorage.getItem('userId')

    const postData = {
      opId: opId
    }

    const response = await callApi('api/platform/certStatus', postData)

    if (response && response.result) {
      setCertYn(response.certYn)
    }
  }

  const getCertFile = async () => {
    let sessionStorage = window.sessionStorage
    let opId = sessionStorage.getItem('userId')
    if (opId) {
      const postData = {
        opId: opId
      }

      const response = await callApi('api/platform/getCertFile', postData)

      if (response && response.result) {

        if (response.derFile) {
          setDerRealFile(response.derFile)
        }
        if (response.keyFile) {
          setKeyRealFile(response.keyFile)
        }

        if (response.kcomwelDerFile) {
          setKcomwelDerRealFile(response.kcomwelDerFile)
        }
        if (response.kcomwelKeyFile) {
          setKcomwelKeyRealFile(response.kcomwelKeyFile)
        }

        if (response.idx) {
          setIdx(response.setIdx)
        }

      }
    }
  }


  useEffect(() => {
    Promise.all([insurancelSetting(), certStatus()]);
  }, [])

  useEffect(() => {
    if (certYn === 'Y') {
      getCertFile();
    }

  }, [certYn]);

  const updateSetting = async () => {
    let sessionStorage = window.sessionStorage
    let opId = sessionStorage.getItem('userId')

    const postData = {
      opId: opId,
      mbGNo: data.mbGNo,
      isNpsSync: toggle1 ? 'Y' : 'N',
      isNhisSync: toggle2 ? 'Y' : 'N',
      isKcomwelMonthlySync: toggle3 ? 'Y' : 'N',
      isKcomwelUnempSync: toggle4 ? 'Y' : 'N'
    }
    const response = await callApi('api/platform/updateSetting', postData)

    if (response.result) {
      snackBar('저장되었습니다.')
    } else {
      snackBar('저장하는데 실패했습니다.')
    }

    insurancelSetting()
  }

  return (
    <div className={styles.insurance_tab}>
      {certYn === 'Y' ?
        <div>
          <Flex justifyContent="space-between" alignItems="center" style={{ margin: '40px 0', height: 50 }}>
            <h3>4대 보험 연동</h3>
            <Button
              width={138}
              onClick={() => updateSetting()}
            >
              저장하기
            </Button>
          </Flex>
          <div className={styles.insurance_table}>
            <span className={styles.insurance_table_column}>연동 대상</span>
            <ul className={styles.insurance_table_column}>
              <li>
                <div>
                  <span className={styles.cell_title}>건강보험</span>
                  <span>고지내역</span>
                </div>
                <Toggle htmlFor="toggle1" checked={toggle1} onChange={e => {
                  setToggle1(e.target.checked)

                }}/>
              </li>
              <li>
                <div>
                  <span className={styles.cell_title}>국민연금</span>
                  <span>결정내역</span>
                </div>
                <Toggle htmlFor="toggle2" checked={toggle2} onChange={e => {
                  setToggle2(e.target.checked)

                }}/>
              </li>
              <li>
                <div>
                  <span className={styles.cell_title}>고용보험</span>
                  <span>당월 보험료</span>
                </div>
                <Toggle htmlFor="toggle3" checked={toggle3} onChange={e => {
                  setToggle3(e.target.checked)

                }}/>
              </li>
              <li>
                <div>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M6 6H8V15H17V17H6V6Z" fill="#D6DAE1"/>
                  </svg>
                  실업급여 지원금
                </div>
                <Toggle htmlFor="toggle4" checked={toggle4} onChange={e => {
                  setToggle4(e.target.checked)

                }}/>
              </li>
              <li>
                <p>
                  매월 건강보험 고지내역, 국민연금 결정내역, 고용보험 당월보험료를 자동으로 가져옵니다.
                </p>
              </li>
            </ul>
          </div>
          <NotificationCard
            style={{
              margin: '24px 0'
            }}
            message={<>
              4대 보험 EDI에서 자동으로 데이터를 가져오는 시각은 아래와 같아요.<br/>
              건강보험 고지내역: 매월 20일 새벽<br/>
              국민연금 결정내역: 매월 24일 새벽<br/>
              고용보험 당월보험료, 사회보험료: 매월 21일 새벽
            </>}
          />
        </div> : null}

      <div className={styles.card} style={{ marginBottom: 200 }}>
        <h4>
          <span>4</span>
          4대 보험 연동
          {
            certYn === 'Y' && <CheckCircleOFFIcon size={16}/>
          }
        </h4>
        <p>
          건강보험 고지내역, 국민연금 결정내역,<br/>
          고용보험 당월보험료, 사회보험료 등을 매월<br/>
          자동으로 가져옵니다.
        </p>
        <Flex justifyContent="space-between">
          {certYn === 'Y' ?
            <Button type="line-gray" width={120} size="sm">
              <PriceCheckIcon size={20}/>
              연동완료
            </Button> :
            <Button
              type="line-gray"
              width={120}
              size="sm"
              onClick={e => {
                setCertImportModal(true)
                setCertUpdate(false)
              }}>
              연동하기
            </Button>}

          <Flex>
            {
              certYn === 'Y' &&
              <IconButton
                style={{ border: 'none', background: 'none' }}
                onClick={e => {
                  setCertImportModal(true)
                  setCertUpdate(true)
                }}>

                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd"
                        d="M16.7212 3.73412C17.7001 2.75529 19.2871 2.75529 20.2659 3.73412C21.2447 4.71295 21.2447 6.29995 20.2659 7.27878L12.4446 15.1001C12.4288 15.1159 12.4131 15.1316 12.3976 15.1471C12.1611 15.384 11.9577 15.5878 11.7127 15.7379C11.4973 15.8699 11.2625 15.9671 11.0169 16.0261C10.7375 16.0932 10.4495 16.0929 10.1148 16.0927C10.0928 16.0926 10.0707 16.0926 10.0484 16.0926H8.67878C8.25273 16.0926 7.90735 15.7472 7.90735 15.3212V13.9516C7.90735 13.9293 7.90734 13.9072 7.90732 13.8852C7.90703 13.5505 7.90679 13.2625 7.97387 12.9831C8.03283 12.7375 8.1301 12.5027 8.26208 12.2873C8.41221 12.0423 8.61601 11.8389 8.85292 11.6024C8.86843 11.5869 8.88409 11.5712 8.89988 11.5554L16.7212 3.73412ZM19.1749 4.82509C18.7986 4.44878 18.1885 4.44878 17.8122 4.82509L9.99085 12.6464C9.68197 12.9553 9.61994 13.0243 9.57758 13.0935C9.53019 13.1708 9.49527 13.2551 9.47409 13.3433C9.45517 13.4221 9.45021 13.5148 9.45021 13.9516V14.5498H10.0484C10.4852 14.5498 10.5779 14.5448 10.6567 14.5259C10.7449 14.5047 10.8292 14.4698 10.9066 14.4224C10.9757 14.38 11.0447 14.318 11.3536 14.0091L19.1749 6.18781C19.5512 5.8115 19.5512 5.20139 19.1749 4.82509ZM7.66521 4.73502L11.1325 4.73502C11.5585 4.73502 11.9039 5.0804 11.9039 5.50645C11.9039 5.9325 11.5585 6.27788 11.1325 6.27788H7.69733C6.9975 6.27788 6.51903 6.27848 6.14857 6.30874C5.78712 6.33828 5.59695 6.39216 5.46139 6.46123C5.14485 6.62252 4.8875 6.87987 4.72621 7.19641C4.65714 7.33197 4.60326 7.52214 4.57373 7.88359C4.54346 8.25405 4.54286 8.73252 4.54286 9.43235V16.3027C4.54286 17.0025 4.54346 17.481 4.57373 17.8514C4.60326 18.2129 4.65714 18.4031 4.72621 18.5386C4.8875 18.8552 5.14485 19.1125 5.46139 19.2738C5.59695 19.3429 5.78712 19.3967 6.14857 19.4263C6.51903 19.4565 6.9975 19.4571 7.69733 19.4571H14.5677C15.2675 19.4571 15.746 19.4565 16.1164 19.4263C16.4779 19.3967 16.668 19.3429 16.8036 19.2738C17.1201 19.1125 17.3775 18.8552 17.5388 18.5386C17.6078 18.4031 17.6617 18.2129 17.6913 17.8514C17.7215 17.481 17.7221 17.0025 17.7221 16.3027V12.8675C17.7221 12.4415 18.0675 12.0961 18.4936 12.0961C18.9196 12.0961 19.265 12.4415 19.265 12.8675V16.3348C19.265 16.9946 19.265 17.5363 19.229 17.9771C19.1917 18.4339 19.1118 18.8497 18.9135 19.2391C18.6043 19.8459 18.1109 20.3393 17.504 20.6485C17.1147 20.8468 16.6989 20.9267 16.2421 20.964C15.8013 21 15.2596 21 14.5998 21H7.66519C7.00539 21 6.46366 21 6.02293 20.964C5.56607 20.9267 5.15026 20.8468 4.76094 20.6485C4.1541 20.3393 3.66072 19.8459 3.35152 19.2391C3.15315 18.8497 3.07332 18.4339 3.03599 17.9771C2.99998 17.5363 2.99999 16.9946 3 16.3348V9.40023C2.99999 8.74043 2.99998 8.19868 3.03599 7.75795C3.07332 7.30109 3.15315 6.88528 3.35152 6.49596C3.66072 5.88912 4.1541 5.39574 4.76094 5.08654C5.15026 4.88817 5.56607 4.80834 6.02293 4.77101C6.46366 4.735 7.00541 4.73501 7.66521 4.73502Z"
                        fill="#8B9099"/>
                </svg>
              </IconButton>
            }
          </Flex>
        </Flex>
      </div>

      {
        certImportModal && (
          <PublicCertImportModal
            open={certImportModal}
            handleOk={() => {
              getCertFile()
              setCertImportModal(false)
            }}
            handleCancel={() => setCertImportModal(false)}
            handlePwError={() => {
              Promise.all([insurancelSetting(), certStatus()]).then(() => {
                setCertImportModal(false)
              })
            }}
            idx={idx}
            derRealFile={derRealFile}
            keyRealFile={keyRealFile}
            kcomwelDerRealFile={kcomwelDerRealFile}
            kcomwelKeyRealFile={kcomwelKeyRealFile}
            update={certUpdate}/>
        )
      }
    </div>
  )
}
